module.exports = __webpack_public_path__ + "assets/img/11_1083.4e46fbb9.jpg";